import { formConstants } from '../constants';

export type FormState = {
  [uid: string]: Record<string, any>;
};

export function form(state: FormState = {}, action: any) {
  switch (action.type) {
    case formConstants.FORM_INIT:
      return {
        ...state,
        [action.payload.uid]: action.payload.values,
      };

    case formConstants.FIELD_CHANGED: {
      const { field, value, uid } = action.payload;

      const existingData = state[uid] || {};

      return {
        ...state,
        [uid]: {
          ...existingData,
          [field]: value,
        },
      };
    }
    case formConstants.FORM_MERGE: {
      const { values, uid } = action.payload;

      const existingData = state[uid] || {};

      return {
        ...state,
        [uid]: {
          ...existingData,
          ...values,
        },
      };
    }
    case formConstants.TERMINATE_FORM: {
      const { uid } = action.payload;
      return {
        ...state,
        [uid]: undefined,
      };
    }
    default:
      return state;
  }
}
